import React from 'react'
import { SearchIcon } from '../icons/SearchIcon'

const ICON_SIZE_SM = 14

export const SearchButton = React.memo(({ label }: { label: string }) => (
  <button
    className="titlebar__search"
    onClick={undefined}
    aria-label={label}
  >
    <SearchIcon size={ICON_SIZE_SM} />
  </button>
))
